import { render, staticRenderFns } from "./year_credit.vue?vue&type=template&id=1ba00afe"
import script from "./year_credit.vue?vue&type=script&lang=js"
export * from "./year_credit.vue?vue&type=script&lang=js"
import style0 from "./year_credit.vue?vue&type=style&index=0&id=1ba00afe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports